import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { myCarsReducer } from '../ducks/reducer';

const rootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    myCars: myCarsReducer,
  });

export default rootReducer;
